var _defs, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassPercentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.78 114.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#11ccea;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 57.39,
    cy: 57.39,
    r: 57.39
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.67,72.63c.43-.9.62-1.38.87-1.83,4.87-9.03,9.78-18.03,14.58-27.09.65-1.23,1.4-1.68,2.71-1.55.94.09,1.9.02,3.16.02-.29.73-.41,1.17-.62,1.56-5.01,9.28-10.04,18.55-15.03,27.84-.43.8-.94,1.11-1.83,1.06-1.14-.06-2.29-.02-3.84-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m53.38,51.41c-.05,2.08-.85,4.39-2.91,6.14-2.17,1.85-5.11,1.84-7.31.03-3.82-3.14-3.95-10.05-.25-13.33,2.48-2.2,5.73-2.1,8.06.27,1.72,1.75,2.41,3.92,2.4,6.89Zm-2.69-.58c.02-2.57-1.61-4.68-3.68-4.79-2.13-.12-3.86,1.74-4.1,4.39-.23,2.61,1.56,5.08,3.77,5.19,2.16.11,4-2.08,4.01-4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.56,64.08c-.08,2.49-.8,4.74-2.71,6.48-2.41,2.19-5.61,2.12-7.96-.14-3.3-3.17-3.37-9.39-.15-12.65,2.47-2.5,5.91-2.53,8.38-.04,1.74,1.74,2.38,3.92,2.43,6.35Zm-10.48-.2c-.05,2.71,1.66,4.9,3.86,4.92,2.24.02,4.04-2.3,3.92-5.01-.11-2.56-1.87-4.6-3.95-4.57-2.06.02-3.78,2.12-3.83,4.67h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.6,26.97v-7.41c2.59.33,5.17.45,7.65,1,15.68,3.49,27.12,15.49,29.49,31.32,3.22,21.58-12.07,40.45-32.17,43-20.83,2.65-39.21-11.15-42.51-31.8-2.75-17.26,7.56-34.83,23.97-40.96,1.37-.51,1.97-.29,2.31,1.12.43,1.7,1,3.35,1.56,5.19-9.69,3.61-16.45,10.16-19.56,20.07-2.22,7.06-1.83,14.14,1.07,20.98,5.79,13.61,20.73,21.12,34.93,17.74,13.25-3.15,24.93-15.62,23.35-32.83-1.35-14.61-13.63-27.11-30.1-27.42Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassPercentIcon);
export default __webpack_public_path__ + "static/media/pass_percent_icon.9234bfb28489fb91054952b81b7cf2db.svg";
export { ForwardRef as ReactComponent };